import Refunded from 'assets/Refound.png'
import Rejected from 'assets/Rejected.png'
import Expired from 'assets/Expired.png'
import Hold from 'assets/Hold.png'
import Disputed from 'assets/Disputed.png'
import Created from 'assets/Created.png'
import DisputeApprovedSuccess from 'assets/DisputeApprovedSuccess.png'
import SolvedByProvider from 'assets/SolvedByProvider.png'
export const IDeliveryType = {
  DELIVERY: 'Delivery',
  PICKUP: 'Pickup'
}

export const OTHER_REASON = {
  OTHER: 'Other'
}

export const StatusEnum = {
  CREATED: 'CREATED',
  DISPUTED: 'DISPUTED',
  DISPUTE_APPROVED: 'DISPUTE_APPROVED',
  HOLD: 'HOLD',
  EXPIRED: 'EXPIRED',
  DENIED: 'DENIED',
  DECLINED: 'DECLINED',
  REJECTED: 'REJECTED',
  REFUNDED: 'REFUNDED',
  ACCEPTED: 'ACCEPTED',
  SOLVED_BY_PROVIDER: 'SOLVED_BY_PROVIDER',
  UNKNOWN: 'UNKNOWN',
  DISPUTE_NOT_ALLOWED: 'DISPUTE_NOT_ALLOWED',
}

export const STATUS_LIST_CHARGEBACK = {
  CREATED: {
    name: 'Created',
    icon: Created,
    color: 'rgba(226, 21, 8, 1)',
    background: 'rgba(226, 21, 8, 0.08)',
    type: 'CREATED',
  },
  DISPUTED: {
    name: 'Disputed',
    icon: Disputed,
    color: 'rgba(255, 138, 0, 1)',
    background: 'rgba(255, 138, 0, 0.08)',
    type: 'DISPUTED',
  },
  DISPUTE_APPROVED: {
    name: 'Dispute-Approved',
    icon: DisputeApprovedSuccess,
    color: '#00984F',
    background: 'rgba(0, 152, 79, 0.08)',
    type: 'DISPUTE_APPROVED',
  },
  HOLD: {
    name: 'Hold',
    icon: Hold,
    color: 'rgba(255, 138, 0, 1)',
    background: 'rgba(255, 138, 0, 0.08)',
    type: 'HOLD',
  },
  EXPIRED: {
    name: 'Expired',
    icon: Expired,
    color: 'rgba(15, 18, 20, 1)',
    background: 'rgba(15, 18, 20, 0.08)',
    type: 'EXPIRED',
  },
  DENIED: {
    name: 'Denied',
    icon: Rejected,
    color: 'rgba(226, 21, 8, 1)',
    background: 'rgba(226, 21, 8, 0.08)',
    type: 'DENIED',
  },
  DECLINED: {
    name: 'Declined',
    icon: Rejected,
    color: 'rgba(226, 21, 8, 1)',
    background: 'rgba(226, 21, 8, 0.08)',
    type: 'DECLINED',
  },
  REJECTED: {
    name: 'Rejected',
    icon: Rejected,
    color: 'rgba(226, 21, 8, 1)',
    background: 'rgba(226, 21, 8, 0.08)',
    type: 'REJECTED',
  },
  REFUNDED: {
    name: 'Refunded',
    icon: Refunded,
    color: '#00984F',
    background: 'rgba(0, 152, 79, 0.08)',
    type: 'REFUNDED'
  },
  ACCEPTED: {
    name: 'Accepted',
    icon: Rejected,
    color: 'rgba(226, 21, 8, 1)',
    background: 'rgba(226, 21, 8, 0.08)',
    type: 'ACCEPTED'
  },
  SOLVED_BY_PROVIDER: {
    name: 'Solved by provider',
    icon: SolvedByProvider,
    color: '#00984F',
    background: 'rgba(0, 152, 79, 0.08)',
    type: 'SOLVED_BY_PROVIDER'
  },
  UNKNOWN: {
    name: 'Unknown',
    icon: Expired,
    color: 'rgba(15, 18, 20, 1)',
    background: 'rgba(15, 18, 20, 0.08)',
    type: 'UNKNOWN',
  },
  DISPUTE_NOT_ALLOWED: {
    name: 'Dispute not allowed',
    icon: Expired,
    color: 'rgba(15, 18, 20, 1)',
    background: 'rgba(15, 18, 20, 0.08)',
    type: 'DISPUTE_NOT_ALLOWED',
  },
}